module.exports = __webpack_public_path__ + "img/spxzf1.cf9a6ab3.png";